<template>
  <div class="desc-base" :class="{right: isRight, hasThumb: hasThumbnail, fortune: isFortuneType }">
    <div class="thumbnail" v-if="hasThumbnail">
      <img v-if="!!item.thumbnail" :src="item.thumbnail" :alt="item.label">
      <span v-else class="nophoto">No Photo</span>
    </div>
    <div class="descriptions" :class="{enableLineClamp: enableLineClamp}">{{item.description}}</div>
  </div>
</template>

<script>
export default {
  name: "SecDescription",
  props: {
    enableLineClamp: {
      type: Boolean,
      default() {
        return false
      }
    },
    itemReceive: {
      type: Object,
      default() {
        return {}
      }
    },
    hasThumbnail: {
      type: Boolean,
      default() {
        return false
      }
    },
    isRight: {
      type: Boolean,
      default() {
        return false
      }
    },
    isFortuneType: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    item() {
      return this.itemReceive
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.desc-base {
  $thumb_bg: $col_gray2;
  $thumbW: 97px;
  $top-padding: 12px;
  $pic-interval: 16px;
  width: 100%;
  padding-top: $top-padding;
  position: relative;
  min-height: 108px;
  &.hasThumb {
    padding-left: $thumbW + $pic-interval;
  }
  .thumbnail {
    overflow: hidden;
    width: $thumbW;
    height: $thumbW;
    //background: $thumb_bg;
    border-radius: $thumbW / 2;
    position: absolute;
    top: $top-padding;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover; //IE注意
    }
    .nophoto {
      line-height: 1;
      font-size: 0.8em;
      color: lighten($thumb_bg, 16%);
      background: $thumb_bg;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .descriptions {
    font-weight: normal;
    font-size: 13px;
    line-height: 21px;
    color: $col_normal_font;
    &.enableLineClamp {
      display: -webkit-box;
      -webkit-line-clamp: 5;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  // サムネイルを右配置
  &.right {
    padding-left: 0;
    padding-right: $thumbW + $pic-interval;
    .thumbnail {
      left: auto;
      right: 0
    }
  }

  &.fortune {
    .thumbnail {
      padding-top: 4px;
      border-radius: 0;
      overflow: visible;
      img {
        height: auto
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SecDescription.vue